import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ==================== PARTNER API ====================

export const getPartners = async () => {
  const response = await api.get('/partners');
  return response.data;
};

export const uploadPartner = async (logoFile, websiteUrl) => {
  const formData = new FormData();
  formData.append('logo', logoFile);
  formData.append('website_url', websiteUrl);
  
  const response = await api.post('/partners', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const deletePartner = async (partnerId) => {
  const response = await api.delete(`/partners/${partnerId}`);
  return response.data;
};

export default api;